import type { TreeTag } from '#domains/tags/types';

export type ToggleOpenPayload = {
  tag: TreeTag;
};

export const toggleOpen = (state: TreeTag[], { tag }: ToggleOpenPayload) => {
  return state.map(t => {
    if (t.id === tag.id) {
      return { ...tag, open: !tag.open };
    }

    if (t.ancestors?.match(tag.id)) {
      return { ...t, open: false };
    }

    return t;
  });
};
